import React, { useState, useEffect, useRef } from 'react';
import './css/statistics.css';
import { useLanguage } from '../context/LanguageContext';

const Statistics = () => {
    const { t } = useLanguage();
    const [isVisible, setIsVisible] = useState(false);
    const [counts, setCounts] = useState({
        clients: 0,
        experience: 0,
        partners: 0
    });
    const sectionRef = useRef(null);

    const statsData = [
        {
            id: 'clients',
            number: 150,
            label: t('statistics.clients') || 'Clients',
            color: '#edc26e',
            suffix: '+'
        },
        {
            id: 'experience',
            number: 5,
            label: t('statistics.experience') || 'Years Experience',
            color: '#2c3e50',
            suffix: '+'
        },
        {
            id: 'partners',
            number: 25,
            label: t('statistics.partners') || 'Partners',
            color: '#e74c3c',
            suffix: '+'
        }
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    animateCounts();
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, [isVisible]);

    const animateCounts = () => {
        statsData.forEach((stat, index) => {
            setTimeout(() => {
                let current = 0;
                const increment = stat.number / 60; // 60 frames for smooth animation
                const timer = setInterval(() => {
                    current += increment;
                    if (current >= stat.number) {
                        current = stat.number;
                        clearInterval(timer);
                    }
                    setCounts(prev => ({
                        ...prev,
                        [stat.id]: Math.floor(current)
                    }));
                }, 16); // ~60fps
            }, index * 200); // Stagger animations
        });
    };

    return (
        <section ref={sectionRef} className="statistics-section">
            <div className="container">
                <div className="section-header">
                    <h2>{t('statistics.title') || 'Our Achievements'}</h2>
                    <p>{t('statistics.subtitle') || 'Numbers that speak for our success'}</p>
                </div>
                
                <div className="stats-grid">
                    {statsData.map((stat, index) => (
                        <div key={stat.id} className="stat-item">
                            <div className="square-container">
                                <div className="square-box" style={{ borderColor: stat.color }}>
                                    <div className="square-content">
                                        <div className="stat-number">
                                            {counts[stat.id]}{stat.suffix}
                                        </div>
                                        <div className="stat-label">{stat.label}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Statistics;

